import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import { Form } from '@/components/form/Form';
import { Loading } from '@/components/loading/Loading';
import { Modal } from '@/components/modal/Modal';
import { ModalProps } from '@/components/modal/useModal';
import { Card } from '@/components/sections/Card';
import { useInviteAdmin } from '@/services/api/hooks/invites';
import { zodResolver } from '@hookform/resolvers/zod';

import { FunctionComponent, Suspense } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';
import { z } from 'zod';
import { TextField } from '../../components/form/fields/text/TextInput';

const InviteAdminFields = z.object({
  email: z.string().email().nonempty()
});

type InviteAdminFields = z.infer<typeof InviteAdminFields>;

export const InviteAdminModal: FunctionComponent<ModalProps> = props => {
  const InviteUsersToMsp = () => {
    const inviteAdmin = useInviteAdmin();
    const methods = useForm<InviteAdminFields>({
      resolver: zodResolver(InviteAdminFields)
    });

    const onSubmit = async (data: InviteAdminFields) => {
      try {
        await inviteAdmin.mutateAsync({
          email: data.email
        });
        toast.success(`Invited ${data.email}`);
        props.close();
      } catch (e) {
        toast.error(`Failed to invite ${data.email}`);
      }
    };

    const errorObj = inviteAdmin.error as Error | undefined;
    const error = errorObj ? errorObj.message : '';

    return (
      <Card className="w-full p-8">
        <Modal.Controls {...props}>
          <h1 className="text-2xl font-semibold">Invite admin</h1>
        </Modal.Controls>

        <Form className="flex w-full flex-col space-y-4 py-3" methods={methods} onSubmit={onSubmit}>
          <TextField label="Email address" id="email" />

          {error && <p className="text-red-500">{error}</p>}

          <div className="flex justify-end pt-2">
            <Button loading={inviteAdmin.isLoading} className="w-fit" variant={ButtonVariant.Primary} type="submit">
              Invite
            </Button>
          </div>
        </Form>
      </Card>
    );
  };

  return (
    <Modal className="md:max-w-xl" {...props}>
      <Suspense fallback={<Loading />}>
        <InviteUsersToMsp />
      </Suspense>
    </Modal>
  );
};
